// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../common/styles/colors.css\"","color-cobalt":"#36415D","colorCobalt":"#36415D","menuItem":"_1NNVI","menuItemContent":"_2l7-t","menuItemChevron":"_2_Qa8"};